<template>
	<div class="dt-header" data-aos="fade-in" data-aos-duration="1500">
        <h2 class="title-1">{{ templateData.label }}</h2>        
        <div 
            v-if="templateData.data_view.ss_enabled || templateData.enable_filters_bar || this.templateData.search"
            class="filters-sorting-reset">
            <button type="reset"
                @click="resetAllFilters"
            >{{ feTheme.reset_all_filters ?? 'Reset all filters' }}</button>
        </div>
        
        <div v-if="templateData.search" class="search-input-form">
            <label for="search-bar-input" class="screenreader-only">Search in Columns</label>
            <input 
                id="search-bar-input" 
                autocomplete="off" 
                data-testid="search-bar-input" 
                type="search" 
                :placeholder="feTheme.search ?? 'Search'" 
                class="Input search-input-field" 
                :data-table="`data-table-${templateData.data_view.id}`"
                @input="searchSubmit"
                v-model.value="searchInput"
                >
            <button type="reset" 
            	class="search-input-reset"
            	@click="searchReset"
            	>
                <span class="screenreader-only">Reset search input</span>
                <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="m12 10.94 4.97-4.97 1.06 1.06L13.06 12l4.97 4.97-1.06 1.06L12 13.06l-4.97 4.97-1.06-1.06L10.94 12 5.97 7.03l1.06-1.06L12 10.94Z" fill="#1F2328"/></svg>
            </button>
            <button type="submit" tabindex="-1" class="search-input-button">
                <span class="screenreader-only">{{ feTheme.search ?? 'Search' }}</span>
                <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 5.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM4 10a6 6 0 1 1 10.74 3.68l5.263 5.262-1.06 1.061-5.264-5.263A5.978 5.978 0 0 1 10 16a6 6 0 0 1-5.999-6Z" fill="#1F2328"/></svg>
            </button>
        </div>

        <template v-if="templateData.top_action_buttons && templateData.top_action_buttons.length">
            <template 
                v-for="button in templateData.top_action_buttons"
                :key="button.index"
                >
                <TopActionButton
                    :button="button"
                    :class="topActionButtonClass"
                    :isFromSecondayComponent="detailsViewId"
                    />
            </template>
        </template>
        <template v-else-if="templateData.top_action_button">
            <TopActionButton
                    :button="templateData.top_action_button"
                    :class="topActionButtonClass"
                    :isFromSecondayComponent="detailsViewId"
                    />
            <!-- <a v-if="templateData.top_action_button"
                class="Btn top-action-button"
                :class="topActionButtonClass"
                :href="templateData.top_action_button.iframe_src"
                :data-module-url="templateData.top_action_button.module.link"
                :data-redirect="getRedirectNode(templateData.top_action_button)"
                >
                - :data-redirect="templateData.top_action_button.params.result_event ? ( 'close-module' == templateData.top_action_button.params.result_event ? 'close-module' : urldecode(templateData.top_action_button.params.redirect_uri ) ) : null" -
                <span v-if="'plus' == templateData.top_action_button.icon" class="mr-2 top-action-button-icon">+</span>
                {{ templateData.top_action_button.button_text }}
            </a> -->
        </template>
    </div>
</template>

<script>

import TopActionButton from '@vueapp/components/dataviews/TopActionButton.vue'

export default {
    name: 'DataviewHeader',
    components: {
        TopActionButton
    },
	props: {
        dtPost: Object,
		templateData: Object,
		feTheme: {
            type: Object,
            default: {}
            }
	},
	data() {
		return {
			searchInput: ''
		}
	},
	emits: ['reset-all', 'search'],
    inject: {
        detailsViewId: {
            from: 'detailsViewId', // this is optional if using the same key for injection
            default: false
        }
    },
	methods: {
		resetAllFilters() {
            this.templateData.table_filters = this.templateData.table_filters.map( item => {
                item.active = false
                return item
            })

            this.emitter.emit('reset-all-ev', {'tableFilters': {}})

            // this.$emit('reset-all', {
            //         'tableFilters': {}
            //     })

            this.searchReset()
        },
        searchSubmit() {
        	this.$emit('search', this.searchInput)
        },
        searchReset() {
        	this.searchInput = ''
        	this.$emit('search', '')
        },
        getRedirectNode( action_btn ) {
            console.log('getRedirectNode::', action_btn)
            if ( ! action_btn.result_event ) return null
            if ( 'close-module' == action_btn.result_event_type ) {
                return 'close-module'
            }
            if ( 'redirect' == action_btn.result_event_type) {
                return decodeURI(action_btn.params.redirect_uri)    
            }
            return null
        }
	},
    computed: {
        topActionButtonClass() {
            return ! this.detailsViewId ? 'Btn--primary' : 'Btn--small Btn--outline'    
        }
    }
}
</script>